import {
  DELETE_BATCH,
  DELETE_BATCH_FILE,
  DELETE_FTP_STORAGE,
  HIDE_ADD_EDIT_BATCH_ENDPOINT_CHILD_MODAL,
  HIDE_ADD_EDIT_BATCH_ENDPOINT_MODAL,
  HIDE_ADD_EDIT_BATCH_FILE_MODAL,
  HIDE_ADD_EDIT_SHEET_CONFIG_MODAL,
  HIDE_ADD_EDIT_STORAGE_MODAL,
  HIDE_BATCH_FILE_LIST_MODAL,
  SET_BATCH_LIST,
  SET_FTP_STORAGE_LIST,
  SHOW_ADD_EDIT_BATCH_ENDPOINT_CHILD_MODAL,
  SHOW_ADD_EDIT_BATCH_ENDPOINT_MODAL,
  SHOW_ADD_EDIT_BATCH_FILE_MODAL,
  SHOW_ADD_EDIT_SHEET_CONFIG_MODAL,
  SHOW_ADD_EDIT_STORAGE_MODAL,
  SHOW_BATCH_FILE_LIST_MODAL,
  UPSERT_BATCH,
  UPSERT_BATCH_FILE,
  UPSERT_FTP_STORAGE,
  SET_ENTITIES_LIST,
  UPDATE_FORM_IN_STORE,
  CHANGE_FILE_TYPE,
  RESET_FORM_IN_STORE,
  REMOVE_ITEM_FROM_EXCEL_SHEET,
  ADD_ITEM_TO_SHEET_CONFIG,
  SET_ENTITY_TO_BATCH_FILE,
  SET_ENTITY_FILE_NAME,
  UPDATE_BATCHFILES_LIST,
  EDIT_SHEET_CONFIG_ITEM,
} from './mutation-types';

export default {
  [SET_FTP_STORAGE_LIST](state, data) {
    state.ftpStorageList = data;
  },
  [UPSERT_FTP_STORAGE](state, {storage, action}) {
    if (action === 'create') {
      state.ftpStorageList.unshift(storage);
    } else if (action === 'update') {
      state.ftpStorageList = state.ftpStorageList.map(s => {
        if (s.name === storage.name) {
          s = storage;
        }
        return s;
      });
    }
  },
  [SET_BATCH_LIST](state, data) {
    state.batchList = data;
  },
  [UPSERT_BATCH](state, {batch, action}) {
    if (action === 'create') {
      state.batchList.unshift(batch);
    } else if (action === 'update') {
      state.batchList = state.batchList.map(b => {
        const idName = b.batchGuid ? 'batchGuid' : 'batchId';
        if (b[idName] === batch[idName]) {
          b = batch;
        }
        return b;
      });
    }
  },
  [UPSERT_BATCH_FILE](state, {batchFile}) {

    state.batchList = state.batchList.map(b => {
      if (b.batchGuid === batchFile.batchGuid) {
        let batchFileExist = false;

        b.batchFiles = b.batchFiles.map(f => {
          if (f.batchFileGuid === batchFile.batchFileGuid) {
            f = batchFile;
            batchFileExist = true;
          }
          return f;
        });

        if (!batchFileExist) {
          b.batchFiles.unshift(batchFile);
        }
      }
      return b;
    });
  },
  [DELETE_BATCH](state, batchGuid) {
    state.batchList = state.batchList.filter(b => (b.batchGuid || b.batchId) !== batchGuid);
  },
  [DELETE_FTP_STORAGE](state, name) {
    state.ftpStorageList = state.ftpStorageList.filter(s => s.name !== name);
  },
  [DELETE_BATCH_FILE](state, batchFile) {
    state.batchList = state.batchList.map(b => {
      if (b.batchGuid === batchFile.batchGuid) {
        b.batchFiles = b.batchFiles.filter(bf => bf.batchFileGuid !== batchFile.batchFileGuid);
      }
      return b;
    });
  },
  [SHOW_ADD_EDIT_STORAGE_MODAL](state, item) {
    state.addEditModal.show = true;
    state.addEditModal.data.item = item;
    state.addEditModal = {...state.addEditModal};
  },
  [HIDE_ADD_EDIT_STORAGE_MODAL](state) {
    state.addEditModal.show = false;
  },
  [SHOW_BATCH_FILE_LIST_MODAL](state, batch) {
    state.batchFileListModal.show = true;
    state.batchFileListModal.data.batch = batch;
    state.batchFileListModal = {...state.batchFileListModal};
  },
  [HIDE_BATCH_FILE_LIST_MODAL](state) {
    state.batchFileListModal.show = false;
  },
  [SHOW_ADD_EDIT_BATCH_FILE_MODAL](state, params) {
    state.addEditBatchFileModal.show = true;
    state.addEditBatchFileModal.data.batchFile = params.batchFile;
    state.addEditBatchFileModal.data.batch = params.batch;
    state.addEditBatchFileModal = {...state.addEditBatchFileModal};
  },
  [HIDE_ADD_EDIT_BATCH_FILE_MODAL](state) {
    state.addEditBatchFileModal.show = false;
  },
  [SHOW_ADD_EDIT_SHEET_CONFIG_MODAL](state, sheetConfig) {
    if(sheetConfig && 'currentEntry' in sheetConfig) {
      state.addEditSheetConfigModal.data.currentEntry = sheetConfig.currentEntry;
    }
    state.addEditSheetConfigModal.show = true;
    state.addEditSheetConfigModal.data.sheetConfig = sheetConfig;
    state.addEditSheetConfigModal = {...state.addEditSheetConfigModal};
  },
  [HIDE_ADD_EDIT_SHEET_CONFIG_MODAL](state) {
    state.addEditSheetConfigModal.show = false;
  },
  [SHOW_ADD_EDIT_BATCH_ENDPOINT_MODAL](state, batch) {
    state.addEditBatchEndpointModal.show = true;
    state.addEditBatchEndpointModal.data.batch = batch;
    state.addEditBatchEndpointModal = {...state.addEditBatchEndpointModal};
  },
  [HIDE_ADD_EDIT_BATCH_ENDPOINT_MODAL](state) {
    state.addEditBatchEndpointModal.show = false;
  },
  [SHOW_ADD_EDIT_BATCH_ENDPOINT_CHILD_MODAL](state, params) {
    state.addEditBatchEndpointChildModal.show = true;
    state.addEditBatchEndpointChildModal.data.batchEndpoints = params.batchEndpoints || [];
  },
  [HIDE_ADD_EDIT_BATCH_ENDPOINT_CHILD_MODAL](state) {
    state.addEditBatchEndpointChildModal.show = false;
  },
  [SET_ENTITIES_LIST](state, payload) {
    state.entitiesList = payload;
  },
  [CHANGE_FILE_TYPE](state, payload) {
    state.formFromStore.batchFileType = payload;
  },
  [UPDATE_FORM_IN_STORE](state, payload) {
    state.formFromStore = payload;
  },
  [RESET_FORM_IN_STORE](state) {
    state.formFromStore = {
      batchFileName: null,
      entityGuid: null,
      batchFileType: null,
      batchFileConfigJSON: null,
      dependencyGroup: 0,
      fileNamePattern: null,
      useColumnPhysicalNames: true,
      delimiter: null,
      sheetConfigs: [],
      batchSize: 0,
    };
  },
  [SET_ENTITY_TO_BATCH_FILE](state, payload){
    state.formFromStore.entityGuid = payload;
  },
  [SET_ENTITY_FILE_NAME](state, payload) {
    state.formFromStore.batchFileName = payload;
  },
  [ADD_ITEM_TO_SHEET_CONFIG](state, payload) {
    state.formFromStore.sheetConfigs.push({
      fileNameColumn: payload.fileNameColumn,
      useColumnPhysicalNames: payload.useColumnPhysicalNames,
      entityGuid: payload.entity.value,
      sheetName: payload.sheetName,
      startRow: payload.startRow,
      startColumn: payload.startColumn,
    });
  },
  [REMOVE_ITEM_FROM_EXCEL_SHEET](state, payload) {
    state.formFromStore.sheetConfigs = state.formFromStore.sheetConfigs.filter((_, idx) =>(
      idx !== payload
    ));
  },
  [UPDATE_BATCHFILES_LIST](state, payload) {
    if(payload.isEditMode) {
      state.batchFileListModal.data.batch.batchFiles = state.batchFileListModal.data.batch.batchFiles.map(el => {
        if(el.batchFileGuid === payload.item.batchFileGuid) {
          return payload.item;
        }
        return el;
      });
    } else {
      state.batchFileListModal.data.batch.batchFiles.push(payload.item);
    }
  },
  [EDIT_SHEET_CONFIG_ITEM](state, payload) {
    state.formFromStore.sheetConfigs = state.formFromStore.sheetConfigs.map(el => {
      if(el.localGuid === payload.localGuid) {
        return payload;
      }
      return el;
    });
  },
};
